/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type EmotionsFilterConfigColumn = (typeof EmotionsFilterConfigColumn)[keyof typeof EmotionsFilterConfigColumn];

export const EmotionsFilterConfigColumn = {
  emotions: 'emotions',
} as const;
